<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ getTitle }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button"
               @click="$router.go(-1)">
              {{ $t('addExerciceComptable.actions.cancel') }}
            </a>
            <a class="button is-addOrEdit" @click="saveExerciceComptable()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         class="mgt-20px"
                         :error="error"
                         :title="'addExerciceComptable.error.problemOccured'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="columns mgt-20px">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{$t('addExerciceComptable.informationExerciceComptable.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="columns">
              <b-field :label="$t('addExerciceComptable.informationExerciceComptable.code')"
              class="column is-3 obligatoire">
                <b-input v-model="exerciceComptable.code"></b-input>
              </b-field>
              <b-field :label="$t('addExerciceComptable.informationExerciceComptable.dateDebut')"
                       class="column is-3 obligatoire">
                <b-datepicker show-week-number
                  nearby-selectable-month-days
                  v-model="exerciceComptable.dateDebut"
                  icon="calendar-today"
                  :editable="true">
                </b-datepicker>
              </b-field>
              <b-field :label="$t('addExerciceComptable.informationExerciceComptable.dateFin')"
                       class="column is-3 obligatoire">
                <b-datepicker show-week-number
                  nearby-selectable-month-days
                  v-model="exerciceComptable.dateFin"
                  icon="calendar-today"
                  :editable="true">
                </b-datepicker>
              </b-field>

              <b-field :label="$t('addExerciceComptable.informationExerciceComptable.etat')"
              class="column is-3">
                <b-select v-model="exerciceComptable.etat" expanded>
                  <option v-for="value in listeEtat"
                          :value="value.code" :key="value.code">
                    {{ $t(value.libelle) }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import formatIsoDate from '@/services/general/formatIsoDate';
import { get, create, update } from '@/api/compta/exerciceComptable/index';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import breadcrumb from '@/components/general/breadcrumb';
import genererExerciceComptable from '@/services/compta/exerciceComptable/genererExerciceComptable';
import validation from '@/services/compta/exerciceComptable/validation';
import { LISTE_ETAT } from '@/configuration/compta/exerciceComptable';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      error: false,
      messages: [],
      exerciceComptable: genererExerciceComptable(),
      listeEtat: LISTE_ETAT,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    errorMsgComponent,
  },
  computed: {
    getTitle() {
      if (this.$route.params.id) return this.$i18n.t('addExerciceComptable.titleEdit');
      return this.$i18n.t('addExerciceComptable.titleAdd');
    },
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeExerciceComptable.title'), route: { name: 'l.parametrage.exercice_comptable' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
    },
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    async saveExerciceComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        const exerciceComptable = cloneDeep(this.exerciceComptable);
        exerciceComptable.dateDebut = formatIsoDate(exerciceComptable.dateDebut);
        exerciceComptable.dateFin = formatIsoDate(exerciceComptable.dateFin);
        if (this.$route.params.id) {
          await update(exerciceComptable);
          messageSuccess(this.$i18n.t('addExerciceComptable.success.edit'));
        } else {
          exerciceComptable.societeId = this.societeActiveId;
          await create(exerciceComptable);
          messageSuccess(this.$i18n.t('addExerciceComptable.success.add'));
        }
        await this.$router.push({ name: 'l.parametrage.exercice_comptable' });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validation(e.response, this.messages);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.exerciceComptable = (await get(this.$route.params.id)).data.result;
        this.exerciceComptable.dateDebut = new Date(this.exerciceComptable.dateDebut);
        this.exerciceComptable.dateFin = new Date(this.exerciceComptable.dateFin);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.exerciceComptable.code }));
      } else this.setInformationPage(this.$t('pageCompta.exerciceComptable.creation'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>

<style scoped>

</style>
